<template>
  <v-container>

      <v-layout v-if="selectedShiftFilter == 'Available Shifts'">
        <v-flex
          v-for="day in daysToRender"
          :key="day | moment('D')"
          class="day-column"
          style="flex: 1 1 0;"
        >
          <v-flex>
            <div>{{ day | moment('D') }}</div>
            <div>{{ day | moment('dddd') }}</div>
          </v-flex>

            <v-flex v-for="shift in availableShiftsOnDay(day)" :key='shift.id' class="week-day-box">
              <router-link :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }">
                <h4>{{ shift.location }}</h4>
              </router-link>
              <div>
                {{ shift.shiftRole }} |
                {{ shift.startDatetime | moment("h:mma") }} -
                {{ shift.endDatetime | moment("h:mma") }}
              </div>
              <div>
                <v-tooltip bottom :disabled="!shift.hasDirections">
                  <v-icon
                    slot="activator"
                    :color="shift.hasDirections ? 'blue' : 'grey lighten-2'"
                    class="shift-details-icon"
                    > location_on </v-icon>
                    <span>Directions Available</span>
                </v-tooltip>

                <v-tooltip bottom :disabled="!shift.hasTravelBonus">
                  <v-icon
                    slot="activator"
                    :color="shift.hasTravelBonus ? 'grey darken-2' : 'grey lighten-2'"
                    class="shift-details-icon"
                    > directions_car </v-icon>
                    <span>{{ shift.travelBonusAmount }}</span>
                </v-tooltip>

                <v-tooltip bottom :disabled="!shift.hasCallInBonus">
                  <v-icon
                    slot="activator"
                    :color="shift.hasCallInBonus ? 'grey darken-2' : 'grey lighten-2'"
                    class="shift-details-icon"
                    > phone </v-icon>
                    <span>{{ shift.callInBonusAmount }}</span>
                </v-tooltip>

                <v-tooltip bottom :disabled="!shift.hasStraightBonus">
                  <v-icon
                    slot="activator"
                    :color="shift.hasStraightBonus ? 'grey darken-2' : 'grey lighten-2'"
                    class="shift-details-icon"
                    > local_atm </v-icon>
                    <span>{{ shift.straightBonusAmount }}</span>
                </v-tooltip>
              </div>
            </v-flex>
        </v-flex>
      </v-layout>

      <v-layout v-else-if="selectedShiftFilter == 'My Shifts'" >
        <v-flex
          v-for="day in daysToRender"
          :key="day | moment('D')"
          class="day-column"
          style="flex: 1 1 0;"
        >
          <v-flex>
            <div>{{ day | moment('D') }}</div>
            <div>{{ day | moment('dddd') }}</div>
          </v-flex>

            <v-flex v-for="shift in myShiftsOnDay(day)" :key='shift.id' class="week-day-box">
              <router-link :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }">
                <h4>{{ shift.location }}</h4>
              </router-link>
              <div>
                {{ shift.shiftRole }} |
                {{ shift.startDatetime | moment("h:mma") }} -
                {{ shift.endDatetime | moment("h:mma") }}
              </div>
              <div>
                <v-tooltip bottom :disabled="!shift.hasDirections">
                  <v-icon
                    slot="activator"
                    :color="shift.hasDirections ? 'blue' : 'grey lighten-2'"
                    class="shift-details-icon"
                    > location_on </v-icon>
                    <span>Directions Available</span>
                </v-tooltip>

                <v-tooltip bottom :disabled="!shift.hasTravelBonus">
                  <v-icon
                    slot="activator"
                    :color="shift.hasTravelBonus ? 'grey darken-2' : 'grey lighten-2'"
                    class="shift-details-icon"
                    > directions_car </v-icon>
                    <span>{{ shift.travelBonusAmount }}</span>
                </v-tooltip>

                <v-tooltip bottom :disabled="!shift.hasCallInBonus">
                  <v-icon
                    slot="activator"
                    :color="shift.hasCallInBonus ? 'grey darken-2' : 'grey lighten-2'"
                    class="shift-details-icon"
                    > phone </v-icon>
                    <span>{{ shift.callInBonusAmount }}</span>
                </v-tooltip>

                <v-tooltip bottom :disabled="!shift.hasStraightBonus">
                  <v-icon
                    slot="activator"
                    :color="shift.hasStraightBonus ? 'grey darken-2' : 'grey lighten-2'"
                    class="shift-details-icon"
                    > local_atm </v-icon>
                    <span>{{ shift.straightBonusAmount }}</span>
                </v-tooltip>
              </div>
            </v-flex>
        </v-flex>
      </v-layout>

      <v-layout v-if="selectedShiftFilter == 'My Shifts'" column>
        <v-flex v-for="(shift, i) in myShiftsInTimePeriod" :key="shift.id">
          <ShiftWithDetails
            :itemData="shift"
            :stripe="i % 2 != 0"
          />
        </v-flex>
      </v-layout>


  </v-container>

</template>

<script>
import ShiftWithDetails from '@/components/shifts/shiftWithDetails.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    ShiftWithDetails,
  },
  computed: {
    ...mapState('calendar', [
      'selectedShiftFilter',
    ]),
    ...mapState('shifts', [
      'owned',
      'available',
    ]),
    ...mapGetters('calendar', [
      'daysToRender',
      'myShiftsInTimePeriod',
      'availableShiftsInTimePeriod',
    ]),
  },
  data: function () {
    return {
    }
  },
  methods: {
    shiftIsOnDay: function (shift, day) {
      return this.$moment(shift.startDatetime).isSame(day, 'day')
    },
    myShiftsOnDay: function(day) {
      return this.myShiftsInTimePeriod.filter(shift => this.shiftIsOnDay(shift, day))
    },
    availableShiftsOnDay: function(day) {
      return this.availableShiftsInTimePeriod.filter(shift => this.shiftIsOnDay(shift, day))
    },
  }
}
</script>

<style scoped>

.day-column {
  padding: 2px;
  border: 1px solid black;
}

.week-day-box {

}

.shift-details-icon {
  cursor: default;
}

</style>
